import { lazy } from 'react';

export const ConfirmRegistrationEmail = lazy(() => import('./ConfirmEmailRegistration.component'));
export const ConfirmUpdateEmail = lazy(() => import('./ConfirmUpdateEmail.component'));
export const ConfirmUpdatePassword = lazy(() => import('./ConfirmUpdatePassword.component'));
